import { AxiosError } from 'axios'; // Importing AxiosError type for type checking
import type { PaymentConsents } from '../types/payment';
import { api } from './calls';
import { handleAxiosError } from './utils';

const getPaymentMethod = async () =>
  await api.get<PaymentConsents | null>('/me/payments')

const updatePaymentMethod = async (
  id: string,
): Promise<{ updated: boolean; message?: string } | null | void> => {
  try {
    if (!id) {
      throw Error("Payment method's consent id is required.")
    }
    const res = await api.put(`/me/payments/${id}`)
    if (res.status === 200) {
      return res.data
    } else {
      return { updated: false, message: "Couldn't set default value" }
    }
  } catch (e) {
    // Type checking the error to ensure it is of AxiosError type or a general Error
    if (e instanceof AxiosError || e instanceof Error) {
      handleAxiosError(e) // Handle Axios or Error instances
    } else {
      handleAxiosError(new Error('An unknown error occurred')) // Fallback for unknown error types
    }
  }
}

const deletePaymentMutation = async (id?: string) => {
  try {
    if (!id) {
      throw Error("Payment method's consent id is required.")
    }
    const res = await api.delete(`/me/payments/${id}`)
    if (res.status === 200) {
      return res.data
    } else {
      return { updated: false, message: "Couldn't set default value" }
    }
  } catch (e) {
    // Type checking the error to ensure it is of AxiosError type or a general Error
    if (e instanceof AxiosError || e instanceof Error) {
      handleAxiosError(e) // Handle Axios or Error instances
    } else {
      handleAxiosError(new Error('An unknown error occurred')) // Fallback for unknown error types
    }
  }
}

export { deletePaymentMutation, getPaymentMethod, updatePaymentMethod };

